import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Bills" hint="Backed by Bill from the shared finance engine." /> }
